import * as React from 'react';
import { useTranslation } from 'react-i18next';
import type { DailyAggregate } from '@etiquetachef/types';
import { formatUsdCents, formatYyyymmddDisplay } from '../formatters';
import { BiTimeChart } from './BiTimeChart';

/**
 * MRR diário em USD equivalente (`mrr.usdEquivalentCents` de
 * `/aggregations/daily/days/{yyyymmdd}`,
 * schema `DailyAggregateSchema` em `packages/types/src/aggregations.ts`).
 *
 * Unidade: o agregado guarda CENTAVOS; o gráfico plota `/ 100` e o `valueFormatter` reconverte
 * com `Math.round(v * 100)` para `formatUsdCents` — mexer só num dos lados mostra valor 100×
 * errado.
 *
 * Origem: sem issue — commit 85642b993, 2026-05-04 15:56 +0200.
 * Usado por: `FinanceDashboardPage` (rota `/dashboard/finance`, `apps/admin`).
 *
 * Histórico:
 *  - 2026-10-10 14:40 +0200 — (#798) cabeçalho padrão (#796); caminho corrigido para
 *    `/aggregations/daily/days/{yyyymmdd}` (o texto omitia `days`).
 */
export function MrrChart({ series }: { series: readonly DailyAggregate[] }): React.JSX.Element {
  const { t } = useTranslation();
  const data = series.map((d) => ({
    x: formatYyyymmddDisplay(d.yyyymmdd),
    y: d.mrr.usdEquivalentCents / 100,
  }));
  return (
    <BiTimeChart
      title={t('finance.charts.mrr')}
      subtitle={t('finance.charts.usdAxis')}
      type="line"
      data={data}
      color="#2563eb"
      valueFormatter={(v): string => formatUsdCents(Math.round(v * 100))}
    />
  );
}
